module.exports = __webpack_public_path__ + "img/menu.f4f14147.svg";